<template>
  <span v-if="!Boolean(event)" class="fault-panel__cell-empty d-flex" disabled> Empty </span>
  <span
    v-else-if="!event.recentEventDate"
    class="fault-panel__cell-empty d-flex"
    @click="goToEventList"
  >
    Impedance Only
  </span>
  <a v-else class="row fault-panel__cell-body" @click="goToEventList">
    <b-col md="12">
      <small>events count</small> {{ event.eventsCount || event.faultEventsCount }}
    </b-col>
    <b-col md="12">
      <small>recent events date</small> {{ changedRecentEventDate.firstPart }} <br />
      {{ changedRecentEventDate.secondPart }}
    </b-col>
  </a>
</template>

<script>
import MomentTimezone from 'moment-timezone';

const FAULT_DEVICE_MAP = {
  Guard1000: 'Guard1000Fault',
  Visnet: 'VisnetHubFaultEventsDefault'
};

export default {
  name: 'FaultEventTile',
  props: {
    event: {
      type: Object,
      required: false
    },
    faultEventParent: {
      type: String,
      required: true
    }
  },
  computed: {
    changedRecentEventDate() {
      const eventDate = this.event.recentEventDate;
      const formatDate = 'DD.MM.YYYY';
      const formatTime = 'HH:mm:ss z';

      if (!eventDate) return null;
      const convertedUnixTimestamp = eventDate * 1000;

      return {
        firstPart: MomentTimezone(convertedUnixTimestamp).format(formatDate),
        secondPart: MomentTimezone(convertedUnixTimestamp).format(formatTime)
      };
    }
  },
  methods: {
    goToEventList() {
      const { phaseNumber, feederNumber } = this.event;

      this.$router.push({
        name: FAULT_DEVICE_MAP[this.faultEventParent],
        params: {
          phaseNumber,
          feederNumber
        }
      });
    }
  }
};
</script>
